import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info?.componentStack);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-[60vh] grid place-items-center p-8">
          <div className="max-w-md w-full rounded-2xl border border-red-200 bg-red-50 p-6" data-testid="error-boundary">
            <div className="font-display text-2xl text-red-900">Something went wrong on this page</div>
            <p className="mt-2 text-sm text-red-800">{String(this.state.error?.message || this.state.error)}</p>
            <button
              onClick={() => { this.setState({ error: null }); window.location.reload(); }}
              className="mt-4 px-4 py-2 rounded-full bg-red-900 text-white text-sm"
              data-testid="error-boundary-reload"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
